const INITIAL_VALUES = {
  branchNum: '',
  branchName: '',
  chain: null,
};

export default INITIAL_VALUES;
